<div class="sidenav-container">
  <mat-toolbar color="primary" class="sidenav-toolbar">
    <img class="logo" ngSrc="../../../assets/img/vsite.svg" alt="vSite Logo" height="24" width="83" />

    <div class="global-add-button">
      <button mat-icon-button (click)="toggleState()" [class.active]="isDropdownOpened" id="dropdown-trigger">
        <mat-icon>add</mat-icon>
      </button>
    </div>
  </mat-toolbar>

  <div class="team-project-selector">
    <mee-team-project-selector></mee-team-project-selector>
  </div>

  <div class="sidenav-scrollbar-container">
    <mat-nav-list class="sidenav-list sidenav-toplevel">
      <mee-sidenav-item *ngFor="let item of items" [item]="item"></mee-sidenav-item>
    </mat-nav-list>
  </div>
</div>
